import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { calc, cssVar } from '@chakra-ui/theme-tools';

const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');
const $diff = cssVar('switch-track-diff');

const diffValue = calc.subtract($width, $height);
const $translateX = cssVar('switch-thumb-x');

const $fontSize = cssVar('switch-track-font-size');
const $fontWeight = cssVar('switch-track-font-weight');
const $lineHeight = cssVar('switch-track-line-height');
const $letterSpacing = cssVar('switch-track-letter-spacing');
const $left = cssVar('switch-track-left');

/**
 * (WIP)
 * @Note: Content inside the switch is not yet implemented in the DLS design.
 * @Note: All the size are TBD and need to be updated based on the DLS design after the design team finalizes the sizes.
 */
export const styleConfig: ComponentStyleConfig = {
  parts: ['container', 'thumb', 'track'],
  baseStyle: {
    container: {
      [$diff.variable]: diffValue,
      [$translateX.variable]: $diff.reference,
      _rtl: {
        [$translateX.variable]: calc($diff).negate().toString(),
      },
      _invalid: {
        borderColor: 'red.500',
      },
    },
    thumb: {
      width: [$height.reference],
      height: [$height.reference],
      _checked: {
        transform: `translateX(${$translateX.reference})`,
      },
    },
    track: {
      width: [$width.reference],
      height: [$height.reference],
      bg: 'grey.100',
      _checked: {
        bg: 'blue.500',
      },
      _before: {
        fontSize: [$fontSize.reference],
        fontWeight: [$fontWeight.reference],
        lineHeight: [$lineHeight.reference],
        right: [$left.reference],
        _checked: {
          left: [$left.reference],
          right: 'auto',
        },
      },
    },
  },
  sizes: {
    sm: {
      container: {
        [$width.variable]: '1.75rem',
        [$height.variable]: '0.75rem',
        [$fontSize.variable]: '12px',
        [$lineHeight.variable]: '16px',
        [$fontWeight.variable]: '700',
        [$letterSpacing.variable]: '-0.75em',
        [$left.variable]: '7px',
      },
      thumb: {},
      track: {},
    },
    md: {
      container: {
        [$width.variable]: '3.125rem',
        [$height.variable]: '1.25rem',
        [$fontSize.variable]: '12px',
        [$lineHeight.variable]: '16px',
        [$fontWeight.variable]: '700',
        [$letterSpacing.variable]: '-0.75em',
        [$left.variable]: '7px',
      },
      thumb: {},
      track: {},
    },
    lg: {
      container: {
        [$width.variable]: '4.25rem',
        [$height.variable]: '1.75rem',
        [$fontSize.variable]: '16px',
        [$lineHeight.variable]: '25px',
        [$fontWeight.variable]: '600',
        [$letterSpacing.variable]: 'less-tight',
        [$left.variable]: '11px',
      },
      thumb: {},
      track: {},
    },
  },
  variants: {
    // Currently, only the 'primary' variant is defined in the DLS design
    primary: {
      container: {},
      thumb: {},
      track: {
        _checked: {
          _focusVisible: {
            bg: 'blue.500',
            borderColor: 'blue.500',
          },
          _hover: {
            bg: 'blue.200',
            borderColor: 'blue.200',
          },
        },
        _disabled: {
          borderColor: 'grey.300',
          _checked: {
            bg: 'blue.200',
            color: 'blue.50',
          },
          _hover: {
            borderColor: 'grey.300',
          },
          _focusVisible: {
            borderColor: 'grey.300',
          },
        },
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
};
